"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _jsonError = require("./jsonError");
var creator = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(response) {
    var lengthFromHeader, bodyArray;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          lengthFromHeader = response.headers.get('content-length');
          if (!(lengthFromHeader !== null)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", Number(lengthFromHeader) > 0 ? response.json() : undefined);
        case 3:
          _context.prev = 3;
          _context.next = 6;
          return response.arrayBuffer();
        case 6:
          bodyArray = _context.sent;
          return _context.abrupt("return", bodyArray.byteLength > 0 ? JSON.parse(new TextDecoder().decode(bodyArray)) : undefined);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](3);
          throw new _jsonError.JsonError('Error reading array buffer or parsing JSON', _context.t0);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 10]]);
  }));
  return function creator(_x) {
    return _ref.apply(this, arguments);
  };
}();
var hasContentTypeError = function hasContentTypeError(response) {
  if (response.headers.get('Content-Type') !== 'application/json') {
    return new Error('Expected Content-Type to be application/json');
  }
  return undefined;
};
var hasMonolithHeaderError = function hasMonolithHeaderError(response) {
  if (response.headers.get('x-json') === null) {
    return new Error('Expected x-json to not be null');
  }
  return undefined;
};
var _default = exports.default = {
  creator: creator,
  validators: {
    hasContentTypeError: hasContentTypeError,
    hasMonolithHeaderError: hasMonolithHeaderError
  }
};
//# sourceMappingURL=json.js.map